import { useSelector } from 'react-redux';

import { selectActiveStatusFilter } from '../../../../store/offerHistory/selectors';
import { EStatus } from '../../../../repositories/valuation-offer-history/entities/offer_history/OfferHistoryStatusCountItemSchema';

/**
 * в таблице офферов есть столбец, который содержит либо данные актуального объявления
 * либо данны на момент снятия
 * Хедер столбца выставляем в зависимости от выбранного фильтра статусов
 * Если выбран "Снятые с публикации" - заголовок "Дата снятия"
 * В остальных случаях - "Текущая цена"
 * */
export const useActualColTitle = () => {
  const statusFiltersActiveIDs = useSelector(selectActiveStatusFilter);

  return statusFiltersActiveIDs && statusFiltersActiveIDs[0] === EStatus.Deactivated ? 'Дата снятия' : 'Текущая цена';
};
